import { useTranslation } from 'react-i18next'
import { cn } from '@chapche/ui'

type NonEditableItemCodeProps = {
  itemCode: string
  /** Override default «код» label (product / property / form). */
  label?: string
  className?: string
}

/**
 * Read-only system code. Must not look like an editable Input.
 */
export function NonEditableItemCode({
  itemCode,
  label,
  className,
}: NonEditableItemCodeProps) {
  const { i18n } = useTranslation()
  const codeLabel = label ?? i18n.t('app.page.listView.code')

  return (
    <div
      className={cn(
        'main__subtitle product__form-label product__form_lowercase flex w-full flex-col gap-8',
        className,
      )}
    >
      <span className="font-montserrat text-s tracking-wide text-ink-muted lowercase">
        {codeLabel}
      </span>
      <div
        role="text"
        aria-readonly="true"
        aria-label={`${codeLabel}: ${itemCode}`}
        className={cn(
          'box-border flex w-full max-w-none items-center',
          'rounded-input border border-dashed border-light-grey bg-disabled px-16 py-12',
          'cursor-default select-all',
        )}
      >
        <code className="font-mono text-l leading-6 break-all text-ink-muted">
          {itemCode}
        </code>
      </div>
    </div>
  )
}

export default NonEditableItemCode
